import { render, staticRenderFns } from "./MediaUpload.vue?vue&type=template&id=4ae80abe&scoped=true&"
import script from "./MediaUpload.vue?vue&type=script&lang=ts&"
export * from "./MediaUpload.vue?vue&type=script&lang=ts&"
import style0 from "./MediaUpload.vue?vue&type=style&index=0&id=4ae80abe&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae80abe",
  null
  
)

export default component.exports